import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimeKeeperDeviceState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: TimeKeeperDeviceState = {
  data: [],
  isLoading: false,
  error: null,
};

const timeKeeperDeviceSlice = createSlice({
  name: 'timeKeeperDevices',
  initialState,
  reducers: {
    setTimeKeeperDevices: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setTimeKeeperDeviceLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTimeKeeperDeviceError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setTimeKeeperDevices, setTimeKeeperDeviceLoading, setTimeKeeperDeviceError } =
  timeKeeperDeviceSlice.actions;

export default timeKeeperDeviceSlice.reducer;
